/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_ViewInputs */

const en_read_along_view = /** @type {(inputs: Read_Along_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const es_read_along_view = /** @type {(inputs: Read_Along_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Read_Along_ViewInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_view = /** @type {((inputs?: Read_Along_ViewInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_ViewInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_view(inputs)
	return en_read_along_view(inputs)
});